export let EntityType = /*#__PURE__*/function (EntityType) {
  EntityType["USER"] = "USER";
  EntityType["TEAM"] = "TEAM";
  EntityType["GROUP"] = "GROUP";
  return EntityType;
}({});

//Previously ServerItem in smart-user-picker